import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { setDate, isSameDay, isSameMonth, isBefore, isAfter, startOfDay, startOfWeek, differenceInCalendarDays, isWithinRange, isDate } from 'date-fns';
import { isFunction, isArray } from '@cloud-sn/v-utils';
import { DATE_STYLE } from '../constant';
import { formatDate } from '../utils';
import getWeek from '../week-utils';
import MultiCalendarMixin from '../mixins/multiCalendar';
export default {
  name: 'DateTBody',
  mixins: [MultiCalendarMixin],
  props: {
    prefixCls: {
      type: String,
      default: undefined
    },
    format: {
      type: String,
      default: undefined
    },
    value: {
      type: Date,
      default: undefined
    },
    selectedValue: {
      type: [Date, Array],
      default: undefined
    },
    hoverValues: {
      type: Array,
      default: undefined
    },
    locale: {
      type: Object,
      default: undefined
    },
    showWeekNumber: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: Function,
      default: undefined
    },
    dateRender: {
      type: Function,
      default: null
    },
    contentRender: {
      type: Function,
      default: null
    }
  },
  computed: {
    dates: function () {
      var value = this.value,
          format = this.format,
          _this$locale = this.locale,
          DateFnsLocale = _this$locale.DateFnsLocale,
          weekStartsOn = _this$locale.WeekLocale.weekStartsOn,
          disabledDate = this.disabledDate,
          selectedValue = this.selectedValue;
      var dates = [];
      var monthStart = setDate(value, 1);
      var weekStart = startOfWeek(monthStart, {
        weekStartsOn: weekStartsOn
      });
      var idx = differenceInCalendarDays(weekStart, monthStart) + 1; // const day = getDay(setDate(value, 1));
      // let idx = 1 - day;

      for (var i = 0; i < DATE_STYLE.row; i += 1) {
        dates[i] = [];

        for (var j = 0; j < DATE_STYLE.col; j += 1) {
          var date = setDate(value, idx);
          dates[i].push({
            id: idx,
            title: formatDate(date, format, {
              locale: DateFnsLocale
            }),
            name: formatDate(date, 'D', {
              locale: DateFnsLocale
            }),
            value: date,
            disabled: disabledDate(date, value, selectedValue)
          });
          idx += 1;
        }
      }

      return dates;
    },
    isRangeCalendar: function isRangeCalendar() {
      var isMultiCalendarChildren = this.isMultiCalendarChildren,
          selectedValue = this.selectedValue;
      return !isMultiCalendarChildren && selectedValue && isArray(selectedValue);
    },
    multiCalendarValueMap: function multiCalendarValueMap() {
      var isMultiCalendarChildren = this.isMultiCalendarChildren,
          selectedValue = this.selectedValue;

      if (isMultiCalendarChildren) {
        if (selectedValue) {
          var values = isArray(selectedValue) ? selectedValue : [selectedValue];
          return values.reduce(function (r, v) {
            var nr = r;

            if (isDate(v)) {
              // 移除时分秒后,获取毫秒数
              nr[startOfDay(v).getTime()] = 1;
            }

            return nr;
          }, {});
        }
      }

      return {};
    }
  },
  methods: {
    cellClasses: function cellClasses(day, j, row) {
      var _ref;

      var prefixCls = this.prefixCls,
          isMultiCalendarChildren = this.isMultiCalendarChildren,
          multiCalendarValueMap = this.multiCalendarValueMap,
          isRangeCalendar = this.isRangeCalendar,
          value = this.value,
          selectedValue = this.selectedValue,
          hoverValues = this.hoverValues;
      var isSelectedDay = false;
      var isInRange = false;
      var isSelectedStartDay = false;
      var isSelectedEndDay = false;

      if (isMultiCalendarChildren) {
        var nDay = day;
        var dayTime = startOfDay(nDay.value).getTime();

        if (dayTime in multiCalendarValueMap) {
          isSelectedDay = true;
          nDay.isSelected = true;
        }
      } else if (isRangeCalendar) {
        var ranges = hoverValues.length > 0 ? hoverValues : selectedValue; // 日历展示会包括部分上月与下月日期, 如果选中需要忽略渲染

        if (isSameMonth(day.value, value)) {
          var startVal = ranges[0];
          var endVal = ranges[1];

          if (startVal) {
            if (isSameDay(day.value, startVal)) {
              isSelectedDay = true;
              isSelectedStartDay = true;
            }

            if (endVal) {
              if (isSameDay(day.value, endVal)) {
                isSelectedDay = true;
                isSelectedEndDay = true;
              } else if (isAfter(startOfDay(day.value), startOfDay(startVal)) && isBefore(startOfDay(day.value), startOfDay(endVal))) {
                isInRange = true;
              }
            }
          }
        } // } else if (isSameDay(day.value, value)) {
        // 与  selected-date 逻辑 一致

      } else if (isSameDay(day.value, selectedValue)) {
        isSelectedDay = true;
      }

      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-cell"), true), _defineProperty(_ref, "".concat(prefixCls, "-today"), isSameDay(day.value, new Date())), _defineProperty(_ref, "".concat(prefixCls, "-selected-date"), isSameDay(day.value, selectedValue)), _defineProperty(_ref, "".concat(prefixCls, "-selected-start-date"), isSelectedStartDay), _defineProperty(_ref, "".concat(prefixCls, "-selected-end-date"), isSelectedEndDay), _defineProperty(_ref, "".concat(prefixCls, "-selected-day"), isSelectedDay), _defineProperty(_ref, "".concat(prefixCls, "-disabled-cell"), day.disabled), _defineProperty(_ref, "".concat(prefixCls, "-in-range-cell"), isInRange), _defineProperty(_ref, "".concat(prefixCls, "-last-month-cell"), !isSameMonth(day.value, value) && day.id <= 0), _defineProperty(_ref, "".concat(prefixCls, "-next-month-btn-day"), !isSameMonth(day.value, value) && day.id > 0), _defineProperty(_ref, "".concat(prefixCls, "-disabled-cell-first-of-row"), day.disabled && (j === 0 || !row[j - 1].disabled)), _defineProperty(_ref, "".concat(prefixCls, "-disabled-cell-last-of-row"), day.disabled && (j === DATE_STYLE.col - 1 || !row[j + 1].disabled)), _ref;
    },
    weekClasses: function weekClasses() {
      var _ref2;

      var dates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var prefixCls = this.prefixCls,
          isRangeCalendar = this.isRangeCalendar,
          hoverValues = this.hoverValues,
          selectedValue = this.selectedValue;

      var _dates = _slicedToArray(dates, 1),
          rangeStart = _dates[0].value;

      var rangeEnd = dates[dates.length - 1].value;
      var isActiveWeek = false;

      if (isRangeCalendar) {
        var ranges = hoverValues.length > 0 ? hoverValues : selectedValue;

        if (isWithinRange(ranges[0], rangeStart, rangeEnd) || isWithinRange(ranges[1], rangeStart, rangeEnd)) {
          isActiveWeek = true;
        }
      } else if (isWithinRange(selectedValue, rangeStart, rangeEnd)) {
        isActiveWeek = true;
      }

      return _ref2 = {}, _defineProperty(_ref2, "".concat(prefixCls, "-current-week"), isWithinRange(new Date(), rangeStart, rangeEnd)), _defineProperty(_ref2, "".concat(prefixCls, "-active-week"), isActiveWeek), _ref2;
    },
    onMouseEnter: function onMouseEnter(day) {
      if (day.disabled) {
        return;
      }

      this.$emit('on-day-hover', day.value);
      this.$emit('day-hover', day.value);
    },
    onSelect: function onSelect(day) {
      var isMultiCalendarChildren = this.isMultiCalendarChildren;

      if (day.disabled) {
        return;
      } // 多选时包含取消操作, 单独处理


      if (isMultiCalendarChildren) {
        if (day.isSelected === true) {
          this.onMultiCalendarUnSelect(day.value);
        } else {
          this.onMultiCalendarSelect(day.value);
        }

        return;
      }

      this.$emit('on-select', day.value);
      this.$emit('select', day.value);
    },
    renderCell: function renderCell(col, idx, date) {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          value = this.value,
          cellClasses = this.cellClasses,
          dateRender = this.dateRender,
          contentRender = this.contentRender,
          onMouseEnter = this.onMouseEnter,
          onSelect = this.onSelect;
      var content = null;

      if (isFunction(dateRender)) {
        content = dateRender({
          current: col.value,
          value: value
        });
      } else {
        var cellContent = isFunction(contentRender) ? contentRender({
          current: col.value,
          value: value
        }) : col.name;
        content = h("div", {
          "class": "".concat(prefixCls, "-date")
        }, [cellContent]);
      }

      return h("td", {
        "attrs": {
          "role": "gridcell",
          "title": col.title
        },
        "class": cellClasses(col, idx, date),
        "on": {
          "mouseenter": function mouseenter() {
            return onMouseEnter(col);
          },
          "click": function click() {
            return onSelect(col);
          }
        }
      }, [content]);
    },
    renderCells: function renderCells() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var renderCell = this.renderCell;
      return range.map(function (col, idx) {
        return renderCell(col, idx, range);
      });
    },
    renderWeekCell: function renderWeekCell() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          WeekLocale = this.locale.WeekLocale;

      var _range = _slicedToArray(range, 1),
          startDay = _range[0];

      return h("td", {
        "class": "".concat(prefixCls, "-week-number-cell")
      }, [getWeek(startDay.value, _objectSpread({}, WeekLocale))]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        dates = this.dates,
        showWeekNumber = this.showWeekNumber,
        weekClasses = this.weekClasses,
        renderWeekCell = this.renderWeekCell,
        renderCells = this.renderCells;
    return h("tbody", {
      "class": "".concat(prefixCls, "-tbody")
    }, [dates.map(function (range, i) {
      var rowAttrs = {
        role: 'row',
        key: i
      };
      var weekCell = null;

      if (showWeekNumber) {
        rowAttrs.class = weekClasses(range);
        weekCell = renderWeekCell(range);
      }

      return h("tr", _mergeJSXProps([{}, rowAttrs]), [weekCell, renderCells(range)]);
    })]);
  }
};